import React from 'react';
import { makeStyles } from '@mui/styles';
import { Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/ErrorOutline';

interface PaymentErrorProps {
    errorMessage: string | null;
}

const useStyles = makeStyles({
    cashWarning: {
        marginTop: '68px',
        display: 'flex',
        textAlign: 'center',
        alignItems: 'center',
    },
    cashWarningText: {
        fontSize: '1.75rem',
    },
    cashErrorIcon: {
        marginRight: '15px',
        fill: 'red',
        width: '3em',
        height: '3em',
    },
    cashErrorText: {
        color: 'red',
    },
});

const PaymentError: React.FC<PaymentErrorProps> = (({ errorMessage }) => {
    const classes = useStyles();

    if (!errorMessage) {
        return null;
    }

    return (<div className={classes.cashWarning}>
        <ErrorIcon className={classes.cashErrorIcon} />
        <Typography
            className={classes.cashErrorText}
            variant='h4'
        >
            {errorMessage}
        </Typography>
    </div>
    );
});

export default (PaymentError);